export default __webpack_public_path__ + "static/media/gtu.9dee48d3.png";